import BaseModel from '../BaseModel';

export default class Domain extends BaseModel {
  static entity = 'domains';

  static primaryKey = 'id';

  static fields() {
    return {
      domain: this.string(null).nullable(),
    };
  }

  static apiConfig = {
    actions: {
      async setDomain(domain) {
        return this.post('companies/domain', {
          domain,
        });
      },
      async getDomain() {
        return this.get('companies/domain');
      },
      async deleteDomain() {
        return this.delete('companies/domain');
      },
      async appliedCheckDomain(domain) {
        return this.post('companies/domain/applied_check', { domain }, { save: false });
      },
    },
  };
}
